// Fetches catalogue health summary data, cached by React Query (30s stale time).
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getHealthData } from '../services/catalogueHealthApi';

const useCatalogueHealthData = (token, amazonConnected, checkingAmazonStatus) => {
  const { data, isLoading, error } = useQuery({
    queryKey: ['catalogue-health-data', token],
    queryFn: () => getHealthData(token),
    enabled: !!token && !!amazonConnected && !checkingAmazonStatus,
    staleTime: 30_000,
    retry: 1,
  });

  return {
    data: data ?? null,
    loading: isLoading,
    error: error?.message ?? null,
  };
};

// Expose cache invalidation so callers can force a refresh after a manual fetch.
export const useClearCatalogueHealthCache = () => {
  const queryClient = useQueryClient();
  return () => queryClient.invalidateQueries({ queryKey: ['catalogue-health-data'] });
};

// Backward-compatible named export for existing callers (MarketPlaceCards etc.)
export const clearCatalogueHealthCache = () => {
  console.warn('clearCatalogueHealthCache() is a no-op outside React. Use useClearCatalogueHealthCache() hook instead.');
};

export default useCatalogueHealthData;
